module.exports = __webpack_public_path__ + "media/bootstrap-icons/printer-408a210c.svg";